import type { PlaybookQuery } from "@qw/graphql";
import { Badge, Icon, Tooltip, TooltipContent, TooltipTrigger } from "@qw/ui";
import type { FC } from "react";

export interface PlaybookSubscribersProps {
  subscribers: PlaybookQuery["playbook"]["subscribers"];
}

export const PlaybookSubscribers: FC<PlaybookSubscribersProps> = ({ subscribers }) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <Badge variant="outline" size="xs" className="text-2xs px-2.5 py-2.5 gap-1">
        <Icon icon="how_to_reg" className="text-xs" /> {subscribers?.length}
      </Badge>
    </TooltipTrigger>
    <TooltipContent side="bottom">
      <div className="flex flex-col gap-1 p-1">
        <div className="font-medium text-muted-foreground">Subscribers</div>
        <ul className="flex flex-col gap-1">
          {subscribers?.map((s) => (
            <li key={s.id}>
              {s.firstName || ""} {s.lastName || ""}
            </li>
          ))}
        </ul>
      </div>
    </TooltipContent>
  </Tooltip>
);
